import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/WhiteBlockTitle.module.scss'

class WhiteBlockTitle extends React.Component {

  render() {

    const { title, text, rcusom, className } = this.props

    return (
      <div className={className != `` ? `${styles.title_line} ${className}` : styles.title_line}>
        <h2 className={styles.title} dangerouslySetInnerHTML={{__html: title}} />
        <div></div>
        {text != '' &&
          <div className={styles.rtext}>{text}</div>
        }
        {rcusom &&
          <>{rcusom}</>
        }
      </div>
    )
  }
}

WhiteBlockTitle.propTypes = {
  title: PropTypes.string,
  text: PropTypes.string,
  rcusom: PropTypes.object,
  className: PropTypes.string
}

WhiteBlockTitle.defaultProps = {
  title: ``,
  text: ``,
  rcusom: false,
  className: ``
}

export default WhiteBlockTitle